module.exports = __webpack_public_path__ + "img/widgets-24px.ffd40e8f.svg";